export default __webpack_public_path__ + "static/lalibrairie-jl-mobile@2x-e4ae584e2b5208a75b637b090cf3024e.jpg";